import { useQuery } from "@tanstack/react-query";

export interface NominatimResult {
  display_name: string;
  lat: string;
  lon: string;
  type: string;
}

export function useLocationSearch(query: string) {
  return useQuery<NominatimResult[]>({
    queryKey: ["nominatim", query],
    queryFn: async ({ signal }) => {
      const url = `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(query)}&format=json&limit=5&addressdetails=0`;
      const res = await fetch(url, {
        signal,
        headers: { "Accept-Language": "de,en" },
      });
      if (!res.ok) return [];
      return res.json();
    },
    enabled: query.length >= 3,
    staleTime: 60_000,
    placeholderData: prev => prev,
  });
}
